import { IconHelpCircle } from '@tabler/icons-react-native';
import { InviteButton } from 'app/components/invite-button';
import { MOBILE_HOME_HEADER_ICON_SIZE } from 'app/components/mobile-home-header-constants';
import { Row } from 'app/design/primitives/box';
import { useNavigation } from 'app/hooks/navigation';
import { isAfter, subMonths } from 'app/lib/date';
import { useUser } from 'app/network/user';
import { useTheme } from 'app/shopify';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { t } from 'i18next';
import { Platform, Pressable } from 'react-native';

export function HeaderLeftInvite() {
  const theme = useTheme();
  const navigation = useNavigation();
  const { data: user } = useUser();
  const showHowItWorks = user?.createdAt ? isAfter(new Date(user.createdAt), subMonths(new Date(), 3)) : false;

  return (
    <Row
      alignItems="center"
      gap="spacing.general.x2"
      style={{
        marginLeft: Platform.OS === 'web' ? theme.spacing['spacing.general.x2'] : -theme.spacing['spacing.general.x2'],
        minHeight: 36,
      }}
    >
      <InviteButton color={theme.colors['text.primary']} iconSize={MOBILE_HOME_HEADER_ICON_SIZE} />
      {showHowItWorks ? (
        <Pressable
          accessibilityRole="button"
          accessibilityLabel={t('howItWorks.title')}
          hitSlop={10}
          onPress={() => navigation.navigate('chat-how-it-works', { isLender: false }, { pop: true })}
        >
          <IconHelpCircle
            strokeWidth={ICON_STROKE_WIDTH}
            size={MOBILE_HOME_HEADER_ICON_SIZE}
            color={theme.colors['white-label.header.bg']}
          />
        </Pressable>
      ) : null}
    </Row>
  );
}
